import { Address } from "./address";
import { Language } from './language';
import { NotificationEvent } from "./notificationEvent";

export class Account {
    name: string;
    accountCode: string;
    email: string;
    mobile: string;
    address: Address = new Address();
    language: string = "en";
    timeZone: any;
    logo: string;
    isManualMRN: Boolean = false;
    isAIEnabled: Boolean = false;
    isEmailReportEnabled: Boolean = false;
    id: number = null;
    readingCenters: any[];
    spectacleVendors: any[];
    aiProviders: any[];
    providerIds: any[] = [];
    isTrial: false;
    trialDays: Number = 15;
    subscriptionType: string;
    rolesForPayment: string;
    hasIndividualOwner: Boolean = false;
    patientPicNeed: Boolean = false;
    dateFormat: any;
    isLoginOTPRequired: Boolean = false;
    autoEmailPatientReport: Boolean = false;
    accountValidityDate: string = null;
    languageList: Language[] = [];
    accountKeyword: string = null;
    enableSMSNotificationOnPatientRegistration: boolean = false;
    enableEmailNotificationOnPatientRegistration: boolean = false;
    notificationEventList: NotificationEvent[] = [];
    enableScreeningEvents: boolean = false;
    slotDuration: any = null;
    enableEmailReportEncryption: Boolean = false;
  accountName?: any;
  accountId?:number;
}